import { client } from 'components/hoc/WithApollo';
import { API_V2 } from 'constants/graphql';
import { LOGOUT } from 'entites/user/logout.graphql';
import Cookies from 'js-cookie';

export async function handleLogOut(redirect = true) {
	const success = await client
		.mutate({
			mutation: LOGOUT,
			context: {
				clientName: API_V2,
			},
		})
		.then((response) => {
			return response.data.logout.success;
		});

	if (success) {
		Cookies.remove('role');
		Cookies.remove('user_id');

		window.db_userId = undefined;
		window.userEmail = undefined;

		if (redirect) {
			window.location.href = `${window.location.origin}/auth/sign-in`;
		}
	}
}
